var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgAsmHero = function SvgAsmHero(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1800 1459",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1181.25 493.479c0 5.429-4.396 9.829-9.821 9.829s-9.821-4.4-9.821-9.829 4.396-9.829 9.821-9.829 9.821 4.4 9.821 9.829Z",
    style: {
      fill: "url(#asm-hero_svg__a)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1181.25 611.413c0 5.429-4.396 9.829-9.821 9.829s-9.821-4.4-9.821-9.829c0-5.425 4.396-9.825 9.821-9.825s9.821 4.4 9.821 9.825Z",
    style: {
      fill: "url(#asm-hero_svg__b)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1181.25 729.35c0 5.425-4.396 9.825-9.821 9.825s-9.821-4.4-9.821-9.825c0-5.429 4.396-9.829 9.821-9.829s9.821 4.4 9.821 9.829Z",
    style: {
      fill: "url(#asm-hero_svg__c)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1181.25 847.283c0 5.43-4.396 9.83-9.821 9.83s-9.821-4.4-9.821-9.83c0-5.429 4.396-9.829 9.821-9.829s9.821 4.4 9.821 9.829Z",
    style: {
      fill: "url(#asm-hero_svg__d)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1189.11 965.217c0 9.771-7.916 17.691-17.679 17.691-9.762 0-17.679-7.92-17.679-17.691 0-9.767 7.917-17.688 17.679-17.688 9.763 0 17.679 7.921 17.679 17.688Z",
    style: {
      fill: "url(#asm-hero_svg__e)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1189.11 1083.15c0 9.771-7.916 17.688-17.679 17.688-9.762 0-17.679-7.917-17.679-17.688 0-9.771 7.917-17.691 17.679-17.691 9.763 0 17.679 7.92 17.679 17.691Z",
    style: {
      fill: "url(#asm-hero_svg__f)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1189.11 1201.09c0 9.77-7.916 17.691-17.679 17.691-9.762 0-17.679-7.921-17.679-17.691 0-9.771 7.917-17.692 17.679-17.692 9.763 0 17.679 7.921 17.679 17.692Z",
    style: {
      fill: "url(#asm-hero_svg__g)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1181.25 1319.02c0 5.429-4.396 9.829-9.821 9.829s-9.821-4.4-9.821-9.829c0-5.425 4.396-9.825 9.821-9.825s9.821 4.4 9.821 9.825Z",
    style: {
      fill: "url(#asm-hero_svg__h)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1306.96 493.479c0 9.771-7.913 17.692-17.676 17.692-9.766 0-17.679-7.921-17.679-17.692s7.913-17.691 17.679-17.691c9.763 0 17.676 7.92 17.676 17.691Z",
    style: {
      fill: "url(#asm-hero_svg__i)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1306.96 611.413c0 9.77-7.913 17.691-17.676 17.691-9.766 0-17.679-7.921-17.679-17.692 0-9.766 7.913-17.687 17.679-17.687 9.763 0 17.676 7.921 17.676 17.688Z",
    style: {
      fill: "url(#asm-hero_svg__j)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1306.96 729.35c0 9.767-7.913 17.688-17.676 17.688-9.766 0-17.679-7.921-17.679-17.688 0-9.771 7.913-17.692 17.679-17.692 9.763 0 17.676 7.921 17.676 17.692Z",
    style: {
      fill: "url(#asm-hero_svg__k)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1306.96 847.283c0 9.771-7.913 17.692-17.676 17.692-9.766 0-17.679-7.921-17.679-17.692 0-9.77 7.913-17.691 17.679-17.691 9.763 0 17.676 7.921 17.676 17.691Z",
    style: {
      fill: "url(#asm-hero_svg__l)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1306.96 965.217c0 9.771-7.913 17.691-17.676 17.691-9.766 0-17.679-7.92-17.679-17.691 0-9.767 7.913-17.688 17.679-17.688 9.763 0 17.676 7.921 17.676 17.688Z",
    style: {
      fill: "url(#asm-hero_svg__m)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1318.75 1083.15c0 16.284-13.192 29.484-29.463 29.484-16.274 0-29.466-13.2-29.466-29.484 0-16.283 13.192-29.483 29.466-29.483 16.271 0 29.463 13.2 29.463 29.483Z",
    style: {
      fill: "url(#asm-hero_svg__n)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1299.11 1201.09c0 5.429-4.4 9.829-9.821 9.829-5.424 0-9.824-4.4-9.824-9.829 0-5.43 4.4-9.83 9.824-9.83 5.421 0 9.821 4.4 9.821 9.83Z",
    style: {
      fill: "url(#asm-hero_svg__o)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1306.96 1319.02c0 9.771-7.913 17.692-17.676 17.692-9.766 0-17.679-7.921-17.679-17.692 0-9.767 7.913-17.688 17.679-17.688 9.763 0 17.676 7.921 17.676 17.688Z",
    style: {
      fill: "url(#asm-hero_svg__p)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1424.82 493.479c0 9.771-7.913 17.692-17.679 17.692-9.763 0-17.679-7.921-17.679-17.692s7.916-17.691 17.679-17.691c9.766 0 17.679 7.92 17.679 17.691Z",
    style: {
      fill: "url(#asm-hero_svg__q)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1436.61 611.413c0 16.283-13.191 29.483-29.466 29.483-16.271 0-29.463-13.2-29.463-29.483 0-16.284 13.192-29.484 29.463-29.484 16.275 0 29.466 13.2 29.466 29.484Z",
    style: {
      fill: "url(#asm-hero_svg__r)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1424.82 729.35c0 9.767-7.913 17.688-17.679 17.688-9.763 0-17.679-7.921-17.679-17.688 0-9.771 7.916-17.692 17.679-17.692 9.766 0 17.679 7.921 17.679 17.692Z",
    style: {
      fill: "url(#asm-hero_svg__s)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1432.68 847.283c0 14.113-11.433 25.555-25.537 25.555-14.1 0-25.534-11.442-25.534-25.555 0-14.112 11.434-25.554 25.534-25.554 14.104 0 25.537 11.442 25.537 25.554Z",
    style: {
      fill: "url(#asm-hero_svg__t)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1416.96 965.217c0 5.429-4.396 9.829-9.821 9.829s-9.821-4.4-9.821-9.829c0-5.425 4.396-9.825 9.821-9.825s9.821 4.4 9.821 9.825Z",
    style: {
      fill: "url(#asm-hero_svg__u)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1424.82 1083.15c0 9.771-7.913 17.688-17.679 17.688-9.763 0-17.679-7.917-17.679-17.688 0-9.771 7.916-17.691 17.679-17.691 9.766 0 17.679 7.92 17.679 17.691Z",
    style: {
      fill: "url(#asm-hero_svg__v)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1436.61 1201.09c0 16.283-13.191 29.483-29.466 29.483-16.271 0-29.463-13.2-29.463-29.483 0-16.284 13.192-29.484 29.463-29.484 16.275 0 29.466 13.2 29.466 29.484Z",
    style: {
      fill: "url(#asm-hero_svg__w)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1424.82 1319.02c0 9.771-7.913 17.692-17.679 17.692-9.763 0-17.679-7.921-17.679-17.692 0-9.767 7.916-17.688 17.679-17.688 9.766 0 17.679 7.921 17.679 17.688Z",
    style: {
      fill: "url(#asm-hero_svg__x)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1550.54 493.479c0 14.113-11.434 25.554-25.538 25.554-14.104 0-25.537-11.441-25.537-25.554 0-14.112 11.433-25.554 25.537-25.554s25.538 11.442 25.538 25.554Z",
    style: {
      fill: "url(#asm-hero_svg__y)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1542.68 611.413c0 9.77-7.916 17.691-17.679 17.691-9.763 0-17.679-7.921-17.679-17.692 0-9.766 7.917-17.687 17.679-17.687 9.763 0 17.679 7.921 17.679 17.688Z",
    style: {
      fill: "url(#asm-hero_svg__z)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1542.68 729.35c0 9.767-7.916 17.688-17.679 17.688-9.763 0-17.679-7.921-17.679-17.688 0-9.771 7.917-17.692 17.679-17.692 9.763 0 17.679 7.921 17.679 17.692Z",
    style: {
      fill: "url(#asm-hero_svg__A)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1550.54 847.283c0 14.113-11.434 25.555-25.538 25.555-14.104 0-25.537-11.442-25.537-25.555 0-14.112 11.433-25.554 25.537-25.554s25.538 11.442 25.538 25.554Z",
    style: {
      fill: "url(#asm-hero_svg__B)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1550.54 965.217c0 14.112-11.434 25.554-25.538 25.554-14.104 0-25.537-11.442-25.537-25.554 0-14.113 11.433-25.55 25.537-25.55s25.538 11.437 25.538 25.55Z",
    style: {
      fill: "url(#asm-hero_svg__C)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1542.68 1083.15c0 9.771-7.916 17.688-17.679 17.688-9.763 0-17.679-7.917-17.679-17.688 0-9.771 7.917-17.691 17.679-17.691 9.763 0 17.679 7.92 17.679 17.691Z",
    style: {
      fill: "url(#asm-hero_svg__D)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1542.68 1201.09c0 9.77-7.916 17.691-17.679 17.691-9.763 0-17.679-7.921-17.679-17.691 0-9.771 7.917-17.692 17.679-17.692 9.763 0 17.679 7.921 17.679 17.692Z",
    style: {
      fill: "url(#asm-hero_svg__E)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1542.68 1319.02c0 9.771-7.916 17.692-17.679 17.692-9.763 0-17.679-7.921-17.679-17.692 0-9.767 7.917-17.688 17.679-17.688 9.763 0 17.679 7.921 17.679 17.688Z",
    style: {
      fill: "url(#asm-hero_svg__F)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1660.54 493.479c0 9.771-7.917 17.692-17.68 17.692-9.766 0-17.679-7.921-17.679-17.692s7.913-17.691 17.679-17.691c9.763 0 17.68 7.92 17.68 17.691Z",
    style: {
      fill: "url(#asm-hero_svg__G)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1660.54 611.413c0 9.77-7.917 17.691-17.68 17.691-9.766 0-17.679-7.921-17.679-17.692 0-9.766 7.913-17.687 17.679-17.687 9.763 0 17.68 7.921 17.68 17.688Z",
    style: {
      fill: "url(#asm-hero_svg__H)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1672.32 729.35c0 16.283-13.192 29.483-29.463 29.483-16.275 0-29.466-13.2-29.466-29.483s13.191-29.483 29.466-29.483c16.271 0 29.463 13.2 29.463 29.483Z",
    style: {
      fill: "url(#asm-hero_svg__I)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1672.32 847.283c0 16.284-13.192 29.484-29.463 29.484-16.275 0-29.466-13.2-29.466-29.484 0-16.283 13.191-29.483 29.466-29.483 16.271 0 29.463 13.2 29.463 29.483Z",
    style: {
      fill: "url(#asm-hero_svg__J)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1672.32 965.217c0 16.283-13.192 29.483-29.463 29.483-16.275 0-29.466-13.2-29.466-29.483 0-16.284 13.191-29.484 29.466-29.484 16.271 0 29.463 13.2 29.463 29.484Z",
    style: {
      fill: "url(#asm-hero_svg__K)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1660.54 1083.15c0 9.771-7.917 17.688-17.68 17.688-9.766 0-17.679-7.917-17.679-17.688 0-9.771 7.913-17.691 17.679-17.691 9.763 0 17.68 7.92 17.68 17.691Z",
    style: {
      fill: "url(#asm-hero_svg__L)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1652.68 1201.09c0 5.429-4.396 9.829-9.821 9.829s-9.821-4.4-9.821-9.829c0-5.43 4.396-9.83 9.821-9.83s9.821 4.4 9.821 9.83Z",
    style: {
      fill: "url(#asm-hero_svg__M)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1660.54 1319.02c0 9.771-7.917 17.692-17.68 17.692-9.766 0-17.679-7.921-17.679-17.692 0-9.767 7.913-17.688 17.679-17.688 9.763 0 17.68 7.921 17.68 17.688Z",
    style: {
      fill: "url(#asm-hero_svg__N)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1790.18 493.479c0 16.284-13.192 29.483-29.466 29.483-16.271 0-29.463-13.199-29.463-29.483 0-16.283 13.192-29.483 29.463-29.483 16.274 0 29.466 13.2 29.466 29.483Z",
    style: {
      fill: "url(#asm-hero_svg__O)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1778.39 611.413c0 9.77-7.913 17.691-17.679 17.691-9.763 0-17.675-7.921-17.675-17.692 0-9.766 7.912-17.687 17.675-17.687 9.766 0 17.679 7.921 17.679 17.688Z",
    style: {
      fill: "url(#asm-hero_svg__P)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1790.18 729.35c0 16.283-13.192 29.483-29.466 29.483-16.271 0-29.463-13.2-29.463-29.483s13.192-29.483 29.463-29.483c16.274 0 29.466 13.2 29.466 29.483Z",
    style: {
      fill: "url(#asm-hero_svg__Q)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1800 847.283c0 21.713-17.587 39.313-39.287 39.313-21.696 0-39.284-17.6-39.284-39.313 0-21.712 17.588-39.312 39.284-39.312 21.7 0 39.287 17.6 39.287 39.312Z",
    style: {
      fill: "url(#asm-hero_svg__R)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1790.18 965.217c0 16.283-13.192 29.483-29.466 29.483-16.271 0-29.463-13.2-29.463-29.483 0-16.284 13.192-29.484 29.463-29.484 16.274 0 29.466 13.2 29.466 29.484Z",
    style: {
      fill: "url(#asm-hero_svg__S)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1790.18 1083.15c0 16.284-13.192 29.484-29.466 29.484-16.271 0-29.463-13.2-29.463-29.484 0-16.283 13.192-29.483 29.463-29.483 16.274 0 29.466 13.2 29.466 29.483Z",
    style: {
      fill: "url(#asm-hero_svg__T)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1778.39 1201.09c0 9.77-7.913 17.691-17.679 17.691-9.763 0-17.675-7.921-17.675-17.691 0-9.771 7.912-17.692 17.675-17.692 9.766 0 17.679 7.921 17.679 17.692Z",
    style: {
      fill: "url(#asm-hero_svg__U)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1778.39 1319.02c0 9.771-7.913 17.692-17.679 17.692-9.763 0-17.675-7.921-17.675-17.692 0-9.767 7.912-17.688 17.675-17.688 9.766 0 17.679 7.921 17.679 17.688Z",
    style: {
      fill: "url(#asm-hero_svg__V)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.963 493.479c0 9.771-7.913 17.692-17.676 17.692-9.766 0-17.679-7.921-17.679-17.692s7.913-17.691 17.679-17.691c9.763 0 17.676 7.92 17.676 17.691Z",
    style: {
      fill: "url(#asm-hero_svg__W)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.75 611.413c0 16.283-13.192 29.483-29.462 29.483-16.276 0-29.467-13.2-29.467-29.483 0-16.284 13.191-29.484 29.466-29.484 16.271 0 29.463 13.2 29.463 29.484Z",
    style: {
      fill: "url(#asm-hero_svg__X)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.75 729.35c0 16.283-13.192 29.483-29.462 29.483-16.276 0-29.467-13.2-29.467-29.483s13.191-29.483 29.466-29.483c16.271 0 29.463 13.2 29.463 29.483Z",
    style: {
      fill: "url(#asm-hero_svg__Y)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.75 847.283c0 16.284-13.192 29.484-29.462 29.484-16.276 0-29.467-13.2-29.467-29.484 0-16.283 13.191-29.483 29.466-29.483 16.271 0 29.463 13.2 29.463 29.483Z",
    style: {
      fill: "url(#asm-hero_svg__Z)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.571 965.217c0 21.712-17.588 39.312-39.284 39.312-21.7 0-39.287-17.6-39.287-39.312 0-21.709 17.587-39.309 39.287-39.309 21.696 0 39.284 17.6 39.284 39.309Z",
    style: {
      fill: "url(#asm-hero_svg__aa)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.75 1083.15c0 16.284-13.192 29.484-29.462 29.484-16.276 0-29.467-13.2-29.467-29.484 0-16.283 13.191-29.483 29.466-29.483 16.271 0 29.463 13.2 29.463 29.483Z",
    style: {
      fill: "url(#asm-hero_svg__ab)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.963 1201.09c0 9.77-7.913 17.691-17.676 17.691-9.766 0-17.679-7.921-17.679-17.691 0-9.771 7.913-17.692 17.679-17.692 9.763 0 17.676 7.921 17.676 17.692Z",
    style: {
      fill: "url(#asm-hero_svg__ac)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.75 1319.02c0 16.283-13.192 29.487-29.462 29.487-16.276 0-29.467-13.204-29.467-29.487 0-16.284 13.191-29.484 29.466-29.484 16.271 0 29.463 13.2 29.463 29.484Z",
    style: {
      fill: "url(#asm-hero_svg__ad)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.821 493.479c0 9.771-7.913 17.692-17.679 17.692-9.763 0-17.679-7.921-17.679-17.692s7.916-17.691 17.679-17.691c9.766 0 17.679 7.92 17.679 17.691Z",
    style: {
      fill: "url(#asm-hero_svg__ae)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.821 611.413c0 9.77-7.913 17.691-17.679 17.691-9.763 0-17.679-7.921-17.679-17.692 0-9.766 7.916-17.687 17.679-17.687 9.766 0 17.679 7.921 17.679 17.688Z",
    style: {
      fill: "url(#asm-hero_svg__af)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.608 729.35c0 16.283-13.191 29.483-29.466 29.483-16.271 0-29.463-13.2-29.463-29.483s13.192-29.483 29.463-29.483c16.275 0 29.466 13.2 29.466 29.483Z",
    style: {
      fill: "url(#asm-hero_svg__ag)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.679 847.283c0 14.113-11.433 25.555-25.537 25.555-14.1 0-25.534-11.442-25.534-25.555 0-14.112 11.434-25.554 25.534-25.554 14.104 0 25.537 11.442 25.537 25.554Z",
    style: {
      fill: "url(#asm-hero_svg__ah)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.429 965.217c0 21.712-17.587 39.312-39.287 39.312-21.696 0-39.284-17.6-39.284-39.312 0-21.709 17.588-39.309 39.284-39.309 21.7 0 39.287 17.6 39.287 39.309Z",
    style: {
      fill: "url(#asm-hero_svg__ai)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.821 1083.15c0 9.771-7.913 17.688-17.679 17.688-9.763 0-17.679-7.917-17.679-17.688 0-9.771 7.916-17.691 17.679-17.691 9.766 0 17.679 7.92 17.679 17.691Z",
    style: {
      fill: "url(#asm-hero_svg__aj)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.429 1201.09c0 21.712-17.587 39.312-39.287 39.312-21.696 0-39.284-17.6-39.284-39.312 0-21.713 17.588-39.313 39.284-39.313 21.7 0 39.287 17.6 39.287 39.313Z",
    style: {
      fill: "url(#asm-hero_svg__ak)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.821 1319.02c0 9.771-7.913 17.692-17.679 17.692-9.763 0-17.679-7.921-17.679-17.692 0-9.767 7.916-17.688 17.679-17.688 9.766 0 17.679 7.921 17.679 17.688Z",
    style: {
      fill: "url(#asm-hero_svg__al)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.821 493.479c0 5.429-4.396 9.829-9.821 9.829s-9.821-4.4-9.821-9.829 4.396-9.829 9.821-9.829 9.821 4.4 9.821 9.829Z",
    style: {
      fill: "url(#asm-hero_svg__am)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.538 611.413c0 14.112-11.434 25.554-25.538 25.554-14.104 0-25.537-11.442-25.537-25.554 0-14.113 11.433-25.55 25.537-25.55s25.538 11.437 25.538 25.549Z",
    style: {
      fill: "url(#asm-hero_svg__an)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.463 729.35c0 16.283-13.192 29.483-29.463 29.483s-29.462-13.2-29.462-29.483 13.191-29.483 29.462-29.483 29.463 13.2 29.463 29.483Z",
    style: {
      fill: "url(#asm-hero_svg__ao)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.463 847.283c0 16.284-13.192 29.484-29.463 29.484s-29.462-13.2-29.462-29.484C670.538 831 683.729 817.8 700 817.8s29.463 13.2 29.463 29.483Z",
    style: {
      fill: "url(#asm-hero_svg__ap)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.538 965.217c0 14.112-11.434 25.554-25.538 25.554-14.104 0-25.537-11.442-25.537-25.554 0-14.113 11.433-25.55 25.537-25.55s25.538 11.437 25.538 25.55Z",
    style: {
      fill: "url(#asm-hero_svg__aq)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.463 1083.15c0 16.284-13.192 29.484-29.463 29.484s-29.462-13.2-29.462-29.484c0-16.283 13.191-29.483 29.462-29.483s29.463 13.2 29.463 29.483Z",
    style: {
      fill: "url(#asm-hero_svg__ar)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.679 1201.09c0 9.77-7.916 17.691-17.679 17.691-9.762 0-17.679-7.921-17.679-17.691 0-9.771 7.917-17.692 17.679-17.692 9.763 0 17.679 7.921 17.679 17.692Z",
    style: {
      fill: "url(#asm-hero_svg__as)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.679 1319.02c0 9.771-7.916 17.692-17.679 17.692-9.762 0-17.679-7.921-17.679-17.692 0-9.767 7.917-17.688 17.679-17.688 9.763 0 17.679 7.921 17.679 17.688Z",
    style: {
      fill: "url(#asm-hero_svg__at)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.679 493.479c0 5.429-4.396 9.829-9.821 9.829s-9.82-4.4-9.82-9.829 4.395-9.829 9.82-9.829c5.425 0 9.821 4.4 9.821 9.829Z",
    style: {
      fill: "url(#asm-hero_svg__au)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835.538 611.413c0 9.77-7.917 17.691-17.68 17.691-9.766 0-17.679-7.921-17.679-17.692 0-9.766 7.913-17.687 17.679-17.687 9.763 0 17.679 7.921 17.679 17.688Z",
    style: {
      fill: "url(#asm-hero_svg__av)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.392 729.35c0 14.113-11.434 25.55-25.534 25.55-14.104 0-25.537-11.437-25.537-25.55 0-14.112 11.433-25.554 25.537-25.554 14.1 0 25.534 11.442 25.534 25.554Z",
    style: {
      fill: "url(#asm-hero_svg__aw)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835.538 847.283c0 9.771-7.917 17.692-17.68 17.692-9.766 0-17.679-7.921-17.679-17.692 0-9.77 7.913-17.691 17.679-17.691 9.763 0 17.679 7.921 17.679 17.691Z",
    style: {
      fill: "url(#asm-hero_svg__ax)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.679 965.217c0 5.429-4.396 9.829-9.821 9.829s-9.82-4.4-9.82-9.829c0-5.425 4.395-9.825 9.82-9.825 5.425 0 9.821 4.4 9.821 9.825Z",
    style: {
      fill: "url(#asm-hero_svg__ay)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835.538 1083.15c0 9.771-7.917 17.688-17.68 17.688-9.766 0-17.679-7.917-17.679-17.688 0-9.771 7.913-17.691 17.679-17.691 9.763 0 17.679 7.92 17.679 17.691Z",
    style: {
      fill: "url(#asm-hero_svg__az)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835.538 1201.09c0 9.77-7.917 17.691-17.68 17.691-9.766 0-17.679-7.921-17.679-17.691 0-9.771 7.913-17.692 17.679-17.692 9.763 0 17.679 7.921 17.679 17.692Z",
    style: {
      fill: "url(#asm-hero_svg__aA)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.679 1319.02c0 5.429-4.396 9.829-9.821 9.829s-9.82-4.4-9.82-9.829c0-5.425 4.395-9.825 9.82-9.825 5.425 0 9.821 4.4 9.821 9.825Z",
    style: {
      fill: "url(#asm-hero_svg__aB)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M945.538 493.479c0 5.429-4.4 9.829-9.825 9.829-5.421 0-9.821-4.4-9.821-9.829s4.4-9.829 9.821-9.829c5.425 0 9.825 4.4 9.825 9.829Z",
    style: {
      fill: "url(#asm-hero_svg__aC)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M965.179 611.413c0 16.283-13.191 29.483-29.466 29.483-16.271 0-29.463-13.2-29.463-29.483 0-16.284 13.192-29.484 29.463-29.484 16.275 0 29.466 13.2 29.466 29.484Z",
    style: {
      fill: "url(#asm-hero_svg__aD)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M953.392 729.35c0 9.767-7.913 17.688-17.679 17.688-9.763 0-17.675-7.921-17.675-17.688 0-9.771 7.912-17.692 17.674-17.692 9.767 0 17.68 7.921 17.68 17.692Z",
    style: {
      fill: "url(#asm-hero_svg__aE)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M953.392 847.283c0 9.771-7.913 17.692-17.679 17.692-9.763 0-17.675-7.921-17.675-17.692 0-9.77 7.912-17.691 17.674-17.691 9.767 0 17.68 7.921 17.68 17.691Z",
    style: {
      fill: "url(#asm-hero_svg__aF)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M945.538 965.217c0 5.429-4.4 9.829-9.825 9.829-5.421 0-9.821-4.4-9.821-9.829 0-5.425 4.4-9.825 9.821-9.825 5.425 0 9.825 4.4 9.825 9.825Z",
    style: {
      fill: "url(#asm-hero_svg__aG)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M953.392 1083.15c0 9.771-7.913 17.688-17.679 17.688-9.763 0-17.675-7.917-17.675-17.688 0-9.771 7.912-17.691 17.674-17.691 9.767 0 17.68 7.92 17.68 17.691Z",
    style: {
      fill: "url(#asm-hero_svg__aH)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M965.179 1201.09c0 16.283-13.191 29.483-29.466 29.483-16.271 0-29.463-13.2-29.463-29.483 0-16.284 13.192-29.484 29.463-29.484 16.275 0 29.466 13.2 29.466 29.484Z",
    style: {
      fill: "url(#asm-hero_svg__aI)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M945.538 1319.02c0 5.429-4.4 9.829-9.825 9.829-5.421 0-9.821-4.4-9.821-9.829 0-5.425 4.4-9.825 9.821-9.825 5.425 0 9.825 4.4 9.825 9.825Z",
    style: {
      fill: "url(#asm-hero_svg__aJ)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.39 493.479c0 5.429-4.396 9.829-9.821 9.829s-9.821-4.4-9.821-9.829 4.396-9.829 9.821-9.829 9.821 4.4 9.821 9.829Z",
    style: {
      fill: "url(#asm-hero_svg__aK)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1071.25 611.413c0 9.77-7.917 17.691-17.679 17.691-9.763 0-17.679-7.921-17.679-17.692 0-9.766 7.916-17.687 17.679-17.687 9.762 0 17.679 7.921 17.679 17.688Z",
    style: {
      fill: "url(#asm-hero_svg__aL)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1071.25 729.35c0 9.767-7.917 17.688-17.679 17.688-9.763 0-17.679-7.921-17.679-17.688 0-9.771 7.916-17.692 17.679-17.692 9.762 0 17.679 7.921 17.679 17.692Z",
    style: {
      fill: "url(#asm-hero_svg__aM)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.39 847.283c0 5.43-4.396 9.83-9.821 9.83s-9.821-4.4-9.821-9.83c0-5.429 4.396-9.829 9.821-9.829s9.821 4.4 9.821 9.829Z",
    style: {
      fill: "url(#asm-hero_svg__aN)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.39 965.217c0 5.429-4.396 9.829-9.821 9.829s-9.821-4.4-9.821-9.829c0-5.425 4.396-9.825 9.821-9.825s9.821 4.4 9.821 9.825Z",
    style: {
      fill: "url(#asm-hero_svg__aO)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.39 1083.15c0 5.425-4.396 9.825-9.821 9.825s-9.821-4.4-9.821-9.825c0-5.429 4.396-9.829 9.821-9.829s9.821 4.4 9.821 9.829Z",
    style: {
      fill: "url(#asm-hero_svg__aP)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1071.25 1201.09c0 9.77-7.917 17.691-17.679 17.691-9.763 0-17.679-7.921-17.679-17.691 0-9.771 7.916-17.692 17.679-17.692 9.762 0 17.679 7.921 17.679 17.692Z",
    style: {
      fill: "url(#asm-hero_svg__aQ)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1071.25 1319.02c0 9.771-7.917 17.692-17.679 17.692-9.763 0-17.679-7.921-17.679-17.692 0-9.767 7.916-17.688 17.679-17.688 9.762 0 17.679 7.921 17.679 17.688Z",
    style: {
      fill: "url(#asm-hero_svg__aR)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.167 0c402.708 0 729.166 326.459 729.166 729.167s-326.458 729.166-729.166 729.166S0 1131.875 0 729.167 326.459 0 729.167 0ZM1375 729.167C1375 1085.85 1085.85 1375 729.167 1375v-239.583h406.25V770.833h-406.25V687.5h406.25V322.917h-406.25V83.333c356.683 0 645.833 289.15 645.833 645.834Zm-645.833-406.25h-406.25V687.5h406.25V322.917Zm0 447.916h-406.25v364.584h406.25V770.833Z",
    style: {
      fill: "#8361ea"
    }
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__a",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__b",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__c",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__d",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__e",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__f",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__g",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__h",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__i",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__j",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__k",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__l",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__m",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__n",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__o",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__p",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__q",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__r",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__s",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__t",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__u",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__v",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__w",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__x",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__y",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__z",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__A",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__B",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__C",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__D",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__E",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__F",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__G",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__H",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__I",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__J",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__K",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__L",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__M",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__N",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__O",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__P",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__Q",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__R",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__S",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__T",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__U",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__V",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__W",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__X",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__Y",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__Z",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__aa",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__ab",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__ac",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__ad",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__ae",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__af",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__ag",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__ah",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__ai",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__aj",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__ak",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__al",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__am",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__an",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__ao",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__ap",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__aq",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__ar",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__as",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__at",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__au",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__av",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__aw",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__ax",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__ay",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__az",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__aA",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__aB",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__aC",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__aD",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__aE",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__aF",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__aG",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__aH",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__aI",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__aJ",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__aK",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__aL",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__aM",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__aN",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__aO",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__aP",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__aQ",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asm-hero_svg__aR",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.608 1133.097 395.899) scale(1648.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  }))));
};
export default SvgAsmHero;